// AIDEV-NOTE: Abstracao de camera — nativo usa Capacitor Camera, web usa input[type=file].
import { Platform } from './platform.detect';

export interface CapturedPhoto {
  path: string; // Caminho nativo (file://...) ou Object URL (blob:...)
  webPath?: string; // URL para exibir em <img>
}

export async function capturePhoto(): Promise<CapturedPhoto> {
  if (Platform.isNative()) {
    const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera');
    const { Capacitor } = await import('@capacitor/core');
    const photo = await Camera.getPhoto({
      quality: 80,
      allowEditing: false,
      resultType: CameraResultType.Uri,
      source: CameraSource.Camera
      // correctOrientation removido — não existe no tipo ImageOptions do Capacitor 6
    });
    return {
      path: photo.path!,
      webPath: Capacitor.convertFileSrc(photo.path!)
    };
  }
  // PWA fallback
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'environment';
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return reject(new Error('Nenhuma foto selecionada'));
      const path = URL.createObjectURL(file);
      resolve({ path, webPath: path });
    };
    input.click();
  });
}
